export default __webpack_public_path__ + "static/jordan-cycling-34c7be73185c7831e9d1f5c81e7990e6.jpeg";